import {
  BarChart3,
  BookUser,
  CreditCard,
  FileText,
  LogOut,
  Users,
  UserCog,
  Settings,
  Lock,
  Bot,
  EyeOff,
  Layers,
} from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../../../../components/UI/Popover";
import { useState } from "react";
import { useSelector } from "react-redux";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "../../../../../components/UI/Avatar";
import { Link } from "react-router-dom";
import ChangePasswordModal from "../../../../Auth/components/ChangePasswordModal";

const UserPopover = ({
  currentUser,
  activeGroup,
  onManageStaffClick,
  onLogoutClick,
  onClickPermission,
  onClickSetting,
  onClickHiddenConversations,
  onOpenStagesManager,
  showManageStaffButton = true,
  showPermissionButton = true,
  showStagesManagerButton = false,
}) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);
  const isChatbotEventEnabled = useSelector(
    (state) => state.chatbotEventAccess.enabled === true,
  );

  // Find the active account or group for avatar display
  const activeAccount = activeGroup
    ? { name: activeGroup.name, avatar: activeGroup.avatar }
    : currentUser;

  return (
    <>
      <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
        <PopoverTrigger asChild>
          <button
            className="flex items-center justify-center w-8 h-8 text-gray-500 hover:bg-secondary rounded-full transition-all duration-200 focus-visible:ring-2 focus-visible:ring-primary/30 focus-visible:outline-none"
            onMouseEnter={() => setIsPopoverOpen(true)}
          >
            <Avatar className="h-6 w-6">
              <AvatarImage
                src={activeAccount?.avatar}
                alt={activeAccount?.name}
              />
              <AvatarFallback>{activeAccount?.name?.charAt(0)}</AvatarFallback>
            </Avatar>
          </button>
        </PopoverTrigger>
        <PopoverContent
          className="w-56 p-0 rounded-xl shadow-lg border border-gray-100"
          onMouseEnter={() => setIsPopoverOpen(true)}
          onMouseLeave={() => setIsPopoverOpen(false)}
          sideOffset={5}
          align="end"
        >
          <div className="py-1.5">
            <div className="px-3 py-2 font-medium text-sm border-b border-gray-100">
              <span>{activeAccount?.name || "Account"}</span>
            </div>

            <div className="mt-1">
              <Link
                to="/contacts"
                target="_blank"
                className="w-full flex items-center px-3 py-2 text-sm hover:bg-gray-50 transition-colors text-left"
                onClick={() => setIsPopoverOpen(false)}
              >
                <BookUser size={16} className="mr-2 text-indigo-500" />
                <span>Danh bạ</span>
              </Link>

              <button
                className="w-full flex items-center px-3 py-2 text-sm hover:bg-gray-50 transition-colors text-left"
                onClick={() => {
                  setIsChangePasswordOpen(true);
                  setIsPopoverOpen(false);
                }}
              >
                <Lock size={16} className="mr-2 text-gray-500" />
                <span>Đổi mật khẩu</span>
              </button>

              <button className="w-full flex items-center px-3 py-2 text-sm hover:bg-gray-50 transition-colors text-left">
                <CreditCard size={16} className="mr-2 text-gray-500" />
                <span>Nâng cấp</span>
              </button>

              <button className="w-full flex items-center px-3 py-2 text-sm hover:bg-gray-50 transition-colors text-left">
                <FileText size={16} className="mr-2 text-gray-500" />
                <span>Hướng dẫn</span>
              </button>

              {showManageStaffButton && (
                <button
                  className="w-full flex items-center px-3 py-2 text-sm hover:bg-gray-50 transition-colors text-left"
                  onClick={() => {
                    onManageStaffClick();
                    setIsPopoverOpen(false);
                  }}
                >
                  <Users size={16} className="mr-2 text-gray-500" />
                  <span>Quản lý nhân viên</span>
                </button>
              )}

              {showPermissionButton && (
                <button
                  className="w-full flex items-center px-3 py-2 text-sm hover:bg-gray-50 transition-colors text-left"
                  onClick={() => {
                    onClickPermission();
                    setIsPopoverOpen(false);
                  }}
                >
                  <UserCog size={16} className="mr-2 text-gray-500" />
                  <span>Phân quyền</span>
                </button>
              )}

              {showStagesManagerButton && (
                <button
                  className="w-full flex items-center px-3 py-2 text-sm hover:bg-gray-50 transition-colors text-left"
                  onClick={() => {
                    onOpenStagesManager?.();
                    setIsPopoverOpen(false);
                  }}
                >
                  <Layers size={16} className="mr-2 text-gray-500" />
                  <span>Cài đặt giai đoạn bán hàng</span>
                </button>
              )}

              <button
                className="w-full flex items-center px-3 py-2 text-sm hover:bg-gray-50 transition-colors text-left"
                onClick={() => {
                  onClickSetting();
                  setIsPopoverOpen(false);
                }}
              >
                <Settings size={16} className="mr-2 text-gray-500" />
                <span>Tag & Tin nhắn nhanh</span>
              </button>

              <Link
                to="/reports/overview"
                target="_blank"
                className="w-full flex items-center px-3 py-2 text-sm hover:bg-gray-50 transition-colors text-left"
                onClick={() => setIsPopoverOpen(false)}
              >
                <BarChart3 size={16} className="mr-2 text-blue-500" />
                <span>Báo cáo</span>
              </Link>

              {isChatbotEventEnabled && (
                <Link
                  to="/chatbot/settings"
                  target="_blank"
                  className="w-full flex items-center px-3 py-2 text-sm hover:bg-gray-50 transition-colors text-left"
                  onClick={() => setIsPopoverOpen(false)}
                >
                  <Bot size={16} className="mr-2 text-gray-500" />
                  <span>Cài đặt ChatBot - Sự kiện</span>
                </Link>
              )}

              <Link
                to="/chatbot/qa"
                target="_blank"
                className="w-full flex items-center px-3 py-2 text-sm hover:bg-gray-50 transition-colors text-left"
                onClick={() => setIsPopoverOpen(false)}
              >
                <Bot size={16} className="mr-2 text-purple-500" />
                <span>Cài đặt QA Bot</span>
              </Link>

              <button
                className="w-full flex items-center px-3 py-2 text-sm hover:bg-gray-50 transition-colors text-left"
                onClick={() => {
                  onClickHiddenConversations?.();
                  setIsPopoverOpen(false);
                }}
              >
                <EyeOff size={16} className="mr-2 text-gray-500" />
                <span>Danh sách hội thoại ẩn</span>
              </button>

              <div className="border-t border-gray-100 mt-1 pt-1">
                <button
                  className="w-full flex items-center px-3 py-2 text-sm hover:bg-gray-50 transition-colors text-left text-red-500"
                  onClick={onLogoutClick}
                >
                  <LogOut size={16} className="mr-2" />
                  <span>Đăng xuất</span>
                </button>
              </div>
            </div>
          </div>
        </PopoverContent>
      </Popover>

      <ChangePasswordModal
        isOpen={isChangePasswordOpen}
        onClose={() => setIsChangePasswordOpen(false)}
        currentUser={currentUser}
      />
    </>
  );
};

export default UserPopover;
